import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import i18n from './i18n';
import App from './App';
import AuthActionHandler from './AuthActionHandler';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Firebase email action links (verify e-mail / reset password / recover e-mail)
// point at our own handler instead of Firebase's default page, which does not
// localize to Czech. Detect the action params up front and render the localized
// handler in place of the game.
const params = new URLSearchParams(window.location.search);
const mode = params.get('mode');
const oobCode = params.get('oobCode');
const lang = params.get('lang');
const AUTH_MODES = ['verifyEmail', 'resetPassword', 'recoverEmail'];

if (AUTH_MODES.includes(mode) && oobCode) {
  // Honour the email's lang param so one handler serves every deployment.
  if (lang && i18n.hasResourceBundle(lang, 'translation')) {
    i18n.changeLanguage(lang);
  }
  root.render(
    <React.StrictMode>
      <AuthActionHandler
        mode={mode}
        oobCode={oobCode}
        continueUrl={params.get('continueUrl') || null}
      />
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
